import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@wegroup/design-system';

// Components
import { IconStatusCheck } from 'wg-fe-ui';

interface Props {
  isCompleted: boolean;
  inProgress?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

const ToolbarProgressBarStep: React.FC<React.PropsWithChildren<Props>> = ({
  isCompleted,
  inProgress,
  children,
  onClick,
  disabled,
}) => {
  return (
    <Wrapper {...(!disabled && { onClick })}>
      <Flex flexDir="column">
        <Box flexShrink={0}>
          {isCompleted ? <IconStatusCheck /> : <IncompleteIcon />}
        </Box>
        <Line className="progress-line" />
      </Flex>
      <Info inProgress={inProgress} disabled={disabled}>
        <p>{children}</p>
      </Info>
    </Wrapper>
  );
};

const Info = styled.div<{
  inProgress?: boolean;
  disabled?: boolean;
}>`
  margin-left: 2.4rem;
  display: grid;
  flex-direction: column;
  grid-gap: 0.8rem;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  > p {
    color: ${({ theme }) =>
      theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]};
    line-height: 2rem;
    text-transform: uppercase;
    text-decoration: ${({ inProgress }) => (inProgress ? 'underline' : 'none')};
    font-weight: 500;
  }
`;

const Line = styled.div`
  background-color: ${({ theme }) =>
    theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]};
  width: 0.1rem;
  height: 100%;
  margin-top: 0.8rem;
`;

const IncompleteIcon = styled.div`
  border: 1px solid
    ${({ theme }) =>
      theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]};
  border-radius: 50px;
  height: 2rem;
  width: 2rem;
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  max-height: 8rem;

  /* Icon and line container */
  > div:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Icon */
  & svg {
    background-color: ${({ theme }) =>
      theme['isImmo'] ? theme.secondary[200] : theme.secondary[300]};
    border-radius: 50%;
    height: 2rem;
    display: block;
    width: 2rem;
    path {
      fill: ${({ theme }) => theme.secondary[800]};
    }
  }

  &:last-of-type {
    height: auto;
  }

  &:last-of-type .progress-line {
    display: none;
  }
`;

export default ToolbarProgressBarStep;
